<template>
  <AppSwitcher/>
</template>

<script>

import AppSwitcher from "@/components/AppSwitcher.vue";

export default {
  name: 'App',
  components: {
    AppSwitcher
  }
}
</script>

<style lang="scss">
*{
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}
</style>
